import { render } from "./Tag.vue?vue&type=template&id=426054d4&scoped=true&ts=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"

import "./Tag.vue?vue&type=style&index=0&id=426054d4&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426054d4"]])

export default __exports__